import React, { useEffect, } from 'react';
import { Form, Row, Col, } from 'react-bootstrap';
import moment from 'moment-timezone';

import ConfigurationService from 'services/configurationService';

import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import fr from 'date-fns/locale/fr';
registerLocale('fr', fr);
setDefaultLocale('fr');

const DemandeDPSStep2 = ({
    register,
    errors,
    setValue,
    watch,
}) => {

    useEffect(() => {
        if(!watch("manifSurVP")){setValue("manifSurVPFermee", false)};
    },[watch("manifSurVP")])

    useEffect(() => {
        if(!watch("manifCircuit")){setValue("manifCircuitCarrossable", false)};
    },[watch("manifCircuit")])

    return (<>
        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Votre évènement</h5></center>
            <Row>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Nom de l'évènement</Form.Label>
                        <Form.Control type="text" name="libelleEvenement" id="libelleEvenement" {...register("libelleEvenement")} isInvalid={!!errors.libelleEvenement}/>
                        <small className="text-danger">{errors.libelleEvenement?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Type d'activité</Form.Label>
                        <Form.Control type="text" name="activiteEvenement" id="activiteEvenement" {...register("activiteEvenement")} isInvalid={!!errors.activiteEvenement}/>
                        <small className="text-danger">{errors.activiteEvenement?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Date</Form.Label>
                        <DatePicker
                            id="dateDebutEvenement"
                            name="dateDebutEvenement"
                            selected={watch("dateDebutEvenement")}
                            onChange={(date)=>{setValue("dateDebutEvenement", date)}}
                            formatWeekDay={day => day.slice(0, 3)}
                            className='form-control'
                            placeholderText="Date de début"
                            dateFormat="dd/MM/yyyy"
                            fixedHeight
                            locale="fr"
                            minDate={new Date()}
                        />
                        <small className="text-danger">{errors.dateDebutEvenement?.message}</small>
                    </Form.Group>
                </Col>
            </Row>
        </div>

        <Row>
            <Col md="6">
                <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
                    <center><h5 className='text-primary mb-2'>L'emplacement</h5></center>
                    <Form.Group className="mb-2">
                        <Form.Label>Lieu de l'évènement</Form.Label>
                        <Form.Control type="text" name="manifNomLieu" id="manifNomLieu" {...register("manifNomLieu")} isInvalid={!!errors.manifNomLieu}/>
                        <small className="text-danger">{errors.manifNomLieu?.message}</small>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Adresse de l'évènement</Form.Label>
                        <Form.Control type="text" name="manifAdresse" id="manifAdresse" {...register("manifAdresse")} isInvalid={!!errors.manifAdresse}/>
                        <small className="text-danger">{errors.manifAdresse?.message}</small>
                    </Form.Group>
                    <Row>
                        <Col md={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Code postal</Form.Label>
                                <Form.Control type="text" name="manifCP" id="manifCP" {...register("manifCP")} isInvalid={!!errors.manifCP}/>
                                <small className="text-danger">{errors.manifCP?.message}</small>
                            </Form.Group>
                        </Col>
                        <Col md={8}>
                            <Form.Group className="mb-2">
                                <Form.Label>Ville</Form.Label>
                                <Form.Control type="text" name="manifVille" id="manifVille" {...register("manifVille")} isInvalid={!!errors.manifVille}/>
                                <small className="text-danger">{errors.manifVille?.message}</small>
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr/>

                    <Form.Group className="mb-2">
                        <Form.Label>Evenement sur route/circuit:</Form.Label>
                        <Form.Check 
                            key="manifSurVP"
                            type='switch'
                            id="manifSurVP"
                            label="Mon évènement emprunte la voie publique"
                            name='manifSurVP'
                            checked={watch("manifSurVP")}
                            onChange={(e)=>{setValue("manifSurVP", e.target.checked)}}
                            isInvalid={!!errors.manifSurVP}
                        />
                        <small className="text-danger">{errors.manifSurVP?.message}</small>
                        <Form.Check 
                            key="manifSurVPFermee"
                            type='switch'
                            id="manifSurVPFermee"
                            label="La portion empruntée est fermée à la circulation"
                            name='manifSurVPFermee'
                            checked={watch("manifSurVPFermee")}
                            onChange={(e)=>{setValue("manifSurVPFermee", e.target.checked)}}
                            disabled={!watch("manifSurVP")}
                            isInvalid={!!errors.manifSurVPFermee}
                        />
                        <small className="text-danger">{errors.manifSurVPFermee?.message}</small>

                        <Form.Check 
                            key="manifCircuit"
                            type='switch'
                            id="manifCircuit"
                            label="Mon évènement est sur circuit"
                            name='manifCircuit'
                            checked={watch("manifCircuit")}
                            onChange={(e)=>{setValue("manifCircuit", e.target.checked)}}
                            isInvalid={!!errors.manifCircuit}
                        />
                        <small className="text-danger">{errors.manifSurVP?.message}</small>
                        <Form.Check 
                            key="manifCircuitCarrossable"
                            type='switch'
                            id="manifCircuitCarrossable"
                            label="Le circuit est entièrement carrossable"
                            name='manifCircuitCarrossable'
                            checked={watch("manifCircuitCarrossable")}
                            onChange={(e)=>{setValue("manifCircuitCarrossable", e.target.checked)}}
                            disabled={!watch("manifCircuit")}
                            isInvalid={!!errors.manifCircuitCarrossable}
                        />
                        <small className="text-danger">{errors.manifCircuitCarrossable?.message}</small>

                        <Form.Check 
                            key="manifInternational"
                            type='switch'
                            id="manifInternational"
                            label="L'évènement passe à l'international"
                            name='manifInternational'
                            checked={watch("manifInternational")}
                            onChange={(e)=>{setValue("manifInternational", e.target.checked)}}
                            disabled={!watch("manifSurVP") && !watch("manifCircuit")}
                            isInvalid={!!errors.manifInternational}
                        />
                        <small className="text-danger">{errors.manifInternational?.message}</small>
                        
                    </Form.Group>
                    
                    <hr/>

                    <Form.Group className="mb-2">
                        <Form.Label>Autres spécificités du site</Form.Label>
                        <Form.Control as="textarea" rows={4} name="manifRisqueSite" id="manifRisqueSite" {...register("manifRisqueSite")} isInvalid={!!errors.manifRisqueSite}/>
                        <small className="text-danger">{errors.manifRisqueSite?.message}</small>
                    </Form.Group>
                </div>
            </Col>
            <Col md="6">
                <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
                    <center><h5 className='text-primary mb-2'>L'accessibilité</h5></center>
                    <Form.Group className="mb-2">
                        <Form.Label>Descriptif du site</Form.Label>
                        <Form.Check 
                            key="e1-0.25"
                            type='radio'
                            id="e1-0.25"
                            label={<>Structures permanentes <small>Bâtiment, salle « en dur »,... Voies publiques, rues,...avec accès dégagés. Conditions d'accès aisés</small></>}
                            name='e1'
                            checked={watch("manifE1Accessibilite") == 0.25}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE1Accessibilite",0.25)}}}
                            isInvalid={!!errors.manifE1Accessibilite}
                        />
                        <Form.Check 
                            key="e1-0.30"
                            type='radio'
                            id="e1-0.30"
                            label={<>Structures non permanentes <small>gradins, tribunes, chapiteaux,... Espaces naturels : &lt;= 2 hectares. 150m &lt; Brancardage &lt;= 300 m. Terrain en pente sur plus de 100 mètres</small></>}
                            name='e1'
                            checked={watch("manifE1Accessibilite") == 0.30}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE1Accessibilite",0.30)}}}
                            isInvalid={!!errors.manifE1Accessibilite}
                        />
                        <Form.Check 
                            key="e1-0.35"
                            type='radio'
                            id="e1-0.35"
                            label={<>Espaces naturels <small>2 ha &lt; surface &lt;= 5 ha . 300 m &lt; Brancardage &lt;= 600 m. Terrain en pente sur plus de 150 mètres. Autres conditions d'accès difficiles</small></>}
                            name='e1'
                            checked={watch("manifE1Accessibilite") == 0.35}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE1Accessibilite",0.35)}}}
                            isInvalid={!!errors.manifE1Accessibilite}
                        />
                        <Form.Check 
                            key="e1-0.40"
                            type='radio'
                            id="e1-0.40"
                            label={<>Espaces naturels <small>surface &gt; 5 hectares. Brancardage : longueur &gt; 600 mètres. Terrain en pente sur plus de 300 mètres. Autres conditions d'accès difficiles : Talus, escaliers, voies d'accès non carrossables,...Progression des secours rendue difficile par la présence du public</small></>}
                            name='e1'
                            checked={watch("manifE1Accessibilite") == 0.40}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE1Accessibilite",0.40)}}}
                            isInvalid={!!errors.manifE1Accessibilite}
                        />
                        <small className="text-danger">{errors.manifE1Accessibilite?.message}</small>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Délais d'intervention des secours publics</Form.Label>
                        <Form.Check 
                            key="e2-0.25"
                            type='radio'
                            id="e2-0.25"
                            label="<= 10 minutes"
                            name='e2'
                            checked={watch("manifE2DelaisSP") == 0.25}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE2DelaisSP",0.25)}}}
                            isInvalid={!!errors.manifE2DelaisSP}
                        />
                        <Form.Check 
                            key="e2-0.30"
                            type='radio'
                            id="e2-0.30"
                            label="> 10 minutes et <= 20 minutes"
                            name='e2'
                            checked={watch("manifE2DelaisSP") == 0.30}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE2DelaisSP",0.30)}}}
                            isInvalid={!!errors.manifE2DelaisSP}
                        />
                        <Form.Check 
                            key="e2-0.35"
                            type='radio'
                            id="e2-0.35"
                            label="> 20 minutes et <= 30 minutes"
                            name='e2'
                            checked={watch("manifE2DelaisSP") == 0.35}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE2DelaisSP",0.35)}}}
                            isInvalid={!!errors.manifE2DelaisSP}
                        />
                        <Form.Check 
                            key="e2-0.40"
                            type='radio'
                            id="e2-0.40"
                            label="> 30 minutes"
                            name='e2'
                            checked={watch("manifE2DelaisSP") == 0.40}
                            onChange={(e)=>{if(e.target.checked){setValue("manifE2DelaisSP",0.40)}}}
                            isInvalid={!!errors.manifE2DelaisSP}
                        />
                        <small className="text-danger">{errors.manifE2DelaisSP?.message}</small>
                    </Form.Group>
                    
                    <Form.Group className="mb-2">
                        <Form.Label>Caserne de pompiers la plus proche</Form.Label>
                        <Form.Control type="text" name="manifSPproches" id="manifSPproches" {...register("manifSPproches")} isInvalid={!!errors.manifSPproches}/>
                        <small className="text-danger">{errors.manifSPproches?.message}</small>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Centre hospitalier le plus proche</Form.Label>
                        <Form.Control type="text" name="manifCHUproches" id="manifCHUproches" {...register("manifCHUproches")} isInvalid={!!errors.manifCHUproches}/>
                        <small className="text-danger">{errors.manifCHUproches?.message}</small>
                    </Form.Group>
                </div>
            </Col>
        </Row>
        

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Accueillir des secouristes</h5></center>

            <Row>
                <Col md="4" className="border-end">
                    <Form.Group className="mb-2">
                        <Form.Label>Le/Les postes de secours:</Form.Label>
                        <Form.Check 
                            key="accueilNA"
                            type='switch'
                            id="accueilNA"
                            label="Il n'y a rien de prévu"
                            name='accueilNA'
                            checked={!watch("accueilTenteIS") && !watch("accueilLocauxIS")}
                            onChange={(e)=>{if(e.target.checked){setValue("accueilTenteIS", false);setValue("accueilLocauxIS", false)}}}
                            isInvalid={!!errors.accueilTenteIS}
                        />
                        <small className="text-danger">{errors.accueilTenteIS?.message}</small>
                        <Form.Check 
                            key="accueilTenteIS"
                            type='switch'
                            id="accueilTenteIS"
                            label="Il y a des tentes dédiées sur place"
                            name='accueilTenteIS'
                            checked={watch("accueilTenteIS")}
                            onChange={(e)=>{setValue("accueilTenteIS", e.target.checked)}}
                            isInvalid={!!errors.accueilTenteIS}
                        />
                        <small className="text-danger">{errors.accueilTenteIS?.message}</small>
                        <Form.Check 
                            key="accueilLocauxIS"
                            type='switch'
                            id="accueilLocauxIS"
                            label="Il y a des locaux en dur dédiés sur place"
                            name='accueilLocauxIS'
                            checked={watch("accueilLocauxIS")}
                            onChange={(e)=>{setValue("accueilLocauxIS", e.target.checked)}}
                            isInvalid={!!errors.accueilLocauxIS}
                        />
                        <small className="text-danger">{errors.accueilLocauxIS?.message}</small>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Le mobilier à disposition des secoursites:</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder='Tables, chaises, ...' name="accueilMobilierIS" id="accueilMobilierIS" {...register("accueilMobilierIS")} isInvalid={!!errors.accueilMobilierIS}/>
                        <small className="text-danger">{errors.accueilMobilierIS?.message}</small>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Les fluides à disposition:</Form.Label>
                        <Form.Check 
                            key="accueilElectricite"
                            type='switch'
                            id="accueilElectricite"
                            label="Electricité"
                            name='accueilElectricite'
                            checked={watch("accueilElectricite")}
                            onChange={(e)=>{setValue("accueilElectricite", e.target.checked)}}
                            isInvalid={!!errors.accueilElectricite}
                        />
                        <small className="text-danger">{errors.accueilElectricite?.message}</small>
                        <Form.Check 
                            key="accueilEau"
                            type='switch'
                            id="accueilEau"
                            label="Eau courante"
                            name='accueilEau'
                            checked={watch("accueilEau")}
                            onChange={(e)=>{setValue("accueilEau", e.target.checked)}}
                            isInvalid={!!errors.accueilEau}
                        />
                        <small className="text-danger">{errors.accueilEau?.message}</small>
                        <Form.Check 
                            key="accueilChauffage"
                            type='switch'
                            id="accueilChauffage"
                            label="Chauffage / Climatisation"
                            name='accueilChauffage'
                            checked={watch("accueilChauffage")}
                            onChange={(e)=>{setValue("accueilChauffage", e.target.checked)}}
                            isInvalid={!!errors.accueilChauffage}
                        />
                        <small className="text-danger">{errors.accueilChauffage?.message}</small>
                        <Form.Check 
                            key="accueilLumiere"
                            type='switch'
                            id="accueilLumiere"
                            label="Lumière"
                            name='accueilLumiere'
                            checked={watch("accueilLumiere")}
                            onChange={(e)=>{setValue("accueilLumiere", e.target.checked)}}
                            isInvalid={!!errors.accueilLumiere}
                        />
                        <small className="text-danger">{errors.accueilLumiere?.message}</small>
                    </Form.Group>
                    <hr/>
                    <Form.Group className="mb-2">
                        <Form.Label>La communication:</Form.Label>
                        <Form.Check 
                            key="accueilRadioOrga"
                            type='switch'
                            id="accueilRadioOrga"
                            label="Une radio sera fournie par l'organiateur"
                            name='accueilRadioOrga'
                            checked={watch("accueilRadioOrga")}
                            onChange={(e)=>{setValue("accueilRadioOrga", e.target.checked)}}
                            isInvalid={!!errors.accueilRadioOrga}
                        />
                        <small className="text-danger">{errors.accueilRadioOrga?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="4" className="border-end">
                    <Form.Group className="mb-2">
                        <Form.Label>Repas:</Form.Label>
                        <Form.Check 
                            key="repas-nenant"
                            type='radio'
                            id="repas-nenant"
                            label={<>L'évènement ne couvre aucune heure de repas<br/>Aucun repas fourni (l'UNASS fournira)</>}
                            name='moyenrepas'
                            checked={!watch("accueilRepas") }
                            onChange={(e)=>{if(e.target.checked){setValue("accueilRepas",false)}}}
                            isInvalid={!!errors.accueilRepas}
                        />
                        <Form.Check 
                            key="repas-tente"
                            type='radio'
                            id="repas-tente"
                            label="Les repas sont fournis par l'organiateur"
                            name='moyenrepas'
                            checked={watch("accueilRepas")}
                            onChange={(e)=>{if(e.target.checked){setValue("accueilRepas",true)}}}
                            isInvalid={!!errors.accueilRepas}
                        />
                        {watch("accueilRepas") ?
                            <><small className="text-info">Un repas doit être composé de : un plat/sandwitch, une boisson, un encas sucré</small></>
                        :
                            <><small className="text-info">Repas nécessaires si le poste couvre les horaires de repas:<br/>
                            {ConfigurationService && ConfigurationService.config['repas'] ? ConfigurationService.config['repas'].map((repas, i)=>{return(
                                <>{repas.labelRepas}: {repas.debutRepasVueOrga} - {repas.finRepasVueOrga}<br/></>
                            )}) :null}
                            </small></>
                        }
                        <small className="text-danger">{errors.accueilRepas?.message}</small>
                    </Form.Group>
                    <hr/>
                    <Form.Group className="mb-2">
                        <Form.Label>Fortes chaleurs:</Form.Label>
                        <Form.Check 
                            key="canicule-nenant"
                            type='radio'
                            id="canicule-nenant"
                            label="Aucune eau n'est prévue en cas de forte chaleur"
                            name='moyencanicule'
                            checked={!watch("accueilEauCanicule") }
                            onChange={(e)=>{if(e.target.checked){setValue("accueilEauCanicule",false)}}}
                            isInvalid={!!errors.accueilEauCanicule}
                        />
                        <Form.Check 
                            key="canicule-tente"
                            type='radio'
                            id="canicule-tente"
                            label="L'organisateur prévoit un stock d'eau adéquat en cas de fortes chaleurs"
                            name='moyencanicule'
                            checked={watch("accueilEauCanicule")}
                            onChange={(e)=>{if(e.target.checked){setValue("accueilEauCanicule",true)}}}
                            isInvalid={!!errors.accueilEauCanicule}
                        />
                        <small className="text-danger">{errors.accueilEauCanicule?.message}</small>
                    </Form.Group>
                    <hr/>
                    <Form.Group className="mb-2">
                        <Form.Label>Local repos secouristes:</Form.Label>
                        <Form.Check 
                            key="repos-nenant"
                            type='radio'
                            id="repos-nenant"
                            label="Aucun local de repos/couchage n'est prévu"
                            name='moyenrepos'
                            checked={!watch("accueilReposIS") }
                            onChange={(e)=>{if(e.target.checked){setValue("accueilReposIS",false)}}}
                            isInvalid={!!errors.accueilReposIS}
                        />
                        <Form.Check 
                            key="repos-tente"
                            type='radio'
                            id="repos-tente"
                            label="L'organisateur met à disposition un local de repos pour les secoursites (évènement long)"
                            name='moyenrepos'
                            checked={watch("accueilReposIS")}
                            onChange={(e)=>{if(e.target.checked){setValue("accueilReposIS",true)}}}
                            isInvalid={!!errors.accueilReposIS}
                        />
                        <small className="text-danger">{errors.accueilReposIS?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="4">
                    <Form.Group className="mb-2">
                        <Form.Label>Autres services sur place:</Form.Label>
                        <Form.Check 
                            key="accueilAutreAASC"
                            type='switch'
                            id="accueilAutreAASC"
                            label="Autre association de secouristes"
                            name='accueilAutreAASC'
                            checked={watch("accueilAutreAASC")}
                            onChange={(e)=>{setValue("accueilAutreAASC", e.target.checked)}}
                            isInvalid={!!errors.accueilAutreAASC}
                        />
                        {watch("accueilAutreAASC") ?
                            <Form.Control className='mb-3' type="text" name="accueilAutreAASCDetails" id="accueilAutreAASCDetails" {...register("accueilAutreAASCDetails")} placeholder="Nom de l'association" isInvalid={!!errors.accueilAutreAASCDetails}/>
                        : null}
                        <Form.Check 
                            key="accueilSME"
                            type='switch'
                            id="accueilSME"
                            label="Société de médicalisation (SME)"
                            name='accueilSME'
                            checked={watch("accueilSME")}
                            onChange={(e)=>{setValue("accueilSME", e.target.checked)}}
                            isInvalid={!!errors.accueilSME}
                        />
                        {watch("accueilSME") ?
                            <Form.Control className='mb-3' type="text" name="accueilSMEDetails" id="accueilSMEDetails" {...register("accueilSMEDetails")} placeholder="Nom de la société" isInvalid={!!errors.accueilSMEDetails}/>
                        : null}
                        <Form.Check 
                            key="accueilMedicalAutreSME"
                            type='switch'
                            id="accueilMedicalAutreSME"
                            label="Médecins hors société de médicalisation (hors-SME)"
                            name='accueilMedicalAutreSME'
                            checked={watch("accueilMedicalAutreSME")}
                            onChange={(e)=>{setValue("accueilMedicalAutreSME", e.target.checked)}}
                            isInvalid={!!errors.accueilMedicalAutreSME}
                        />
                        <Form.Check 
                            key="accueilAP"
                            type='switch'
                            id="accueilAP"
                            label="Ambulance privée"
                            name='accueilAP'
                            checked={watch("accueilAP")}
                            onChange={(e)=>{setValue("accueilAP", e.target.checked)}}
                            isInvalid={!!errors.accueilAP}
                        />
                        <Form.Check 
                            key="accueilSAMU"
                            type='switch'
                            id="accueilSAMU"
                            label="SAMU"
                            name='accueilSAMU'
                            checked={watch("accueilSAMU")}
                            onChange={(e)=>{setValue("accueilSAMU", e.target.checked)}}
                            isInvalid={!!errors.accueilSAMU}
                        />
                        <Form.Check 
                            key="accueilSP"
                            type='switch'
                            id="accueilSP"
                            label="Sapeurs-Pompiers"
                            name='accueilSP'
                            checked={watch("accueilSP")}
                            onChange={(e)=>{setValue("accueilSP", e.target.checked)}}
                            isInvalid={!!errors.accueilSP}
                        />
                        <Form.Check 
                            key="accueilFDO"
                            type='switch'
                            id="accueilFDO"
                            label="Police / Gendarmerie"
                            name='accueilFDO'
                            checked={watch("accueilFDO")}
                            onChange={(e)=>{setValue("accueilFDO", e.target.checked)}}
                            isInvalid={!!errors.accueilFDO}
                        />
                        <Form.Check 
                            key="accueilSecuPrivee"
                            type='switch'
                            id="accueilSecuPrivee"
                            label="Sécurité privée"
                            name='accueilSecuPrivee'
                            checked={watch("accueilSecuPrivee")}
                            onChange={(e)=>{setValue("accueilSecuPrivee", e.target.checked)}}
                            isInvalid={!!errors.accueilSecuPrivee}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </div>

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Autres remarques</h5></center>
            <Form.Group className="mb-2">
                <Form.Control as="textarea" rows={4} name="manifRemarques" id="manifRemarques" {...register("manifRemarques")} isInvalid={!!errors.manifRemarques}/>
                <small className="text-danger">{errors.manifRemarques?.message}</small>
            </Form.Group>
        </div>

    </>);
};


DemandeDPSStep2.propTypes = {};

export default DemandeDPSStep2;